/**
 * FinanceBillingARWithNotifications — Iter-160 · Phase 4 → rewritten
 * in Iter-163 · Phase 5 as the unified Finance Billing & A/R view.
 *
 * Sections (top-down):
 *   1. Unified billing notifications feed (in-app + email + SMS).
 *   2. Call Required tasks (sorted by days overdue DESC).
 *   3. Record Check Payment action.
 *   4. Global invoice table (BillingARBoard).
 */
import { useCallback, useState } from 'react';
import UnifiedBillingNotifications from './UnifiedBillingNotifications';
import CallRequiredTasks from './CallRequiredTasks';
import RecordCheckPayment from './RecordCheckPayment';
// Iter-165 · Phases 3 + 4 — analytics tile + digest preview.
import AutopayFunnelTile from './AutopayFunnelTile';
import DigestPreviewPanel from './DigestPreviewPanel';
import { BillingARBoard } from './PropertiesBoards';

/** Kept for backwards compat — the Finance CC tab previously wired
 * a live badge from this hook. Iter-163 removes the badge in favor of
 * the inline unified panel, so the hook now returns zero (badge is
 * hidden). We keep the export shape so the tab config doesn't break. */
export function useFinanceUnreadCount() {
  const [count] = useState(0);
  const refresh = useCallback(() => {}, []);
  return { count, refresh };
}

export default function FinanceBillingARWithNotifications({ onCountChange }) {
  const refresh = useCallback(() => { onCountChange && onCountChange(); }, [onCountChange]);
  return (
    <div className="space-y-5" data-testid="finance-billing-ar-with-notifications">
      <AutopayFunnelTile />
      <UnifiedBillingNotifications scope="finance" onChange={refresh} />
      <CallRequiredTasks />
      <DigestPreviewPanel />
      <RecordCheckPayment onRecorded={refresh} />
      <BillingARBoard />
    </div>
  );
}
